import { Icon } from "@/react/components/shared/Icon";
import { Button } from "@/react/components/shared/uikit/Button";
import { Typography } from "@/react/components/shared/uikit/Typography";

interface ItemClickableProps {
  onClick: () => void;
  title: string;
}

export const ItemClickable = ({ title, onClick }: ItemClickableProps) => (
  <Button
    className="text-dark hover:bg-secondary -mx-3 flex flex-row justify-between !px-3 !py-1"
    onClick={onClick}
    variant="circle-plain"
    isFullRounded={false}
  >
    <Typography.BodySm>{title}</Typography.BodySm>
    <Icon type="24-arrow-right" />
  </Button>
);
